export default __webpack_public_path__ + "static/media/LawYears60s.57c3d6d6.mp3";